import {
  FIELDTYPE_BODYINFORMATION,
  FIELDTYPE_CONCLUSION,
  FIELDTYPE_IMAGE,
  FIELDTYPE_SUMMARY,
  FIELDTYPE_TITLE,
} from '../constants/api';
import * as fields from '../app/agora/routes/renderHearing/fields';

export const resolveField = (fieldType) => {
  const componentName = mapTypeToComponentName(fieldType);
  return componentName && fields[componentName];
};

const mapTypeToComponentName = (type) => {
  switch (type) {
    case FIELDTYPE_TITLE:
      return 'TitleField';
    case FIELDTYPE_IMAGE:
      return 'FrontImageField';
    case FIELDTYPE_SUMMARY:
      return 'SummaryField';
    case FIELDTYPE_BODYINFORMATION:
      return 'BodyInformationField';
    case FIELDTYPE_CONCLUSION:
      return 'ConclusionField';
    default:
      return null;
  }
};
